import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const PortalApi = createApi(config.PORTAL_API_URL);

export default PortalApi;
